import Vue from 'vue';
import Component from 'vue-class-component';
import {EnvironmentBar} from './environment-bar';
import {Footer} from './footer';
import {AuthorisationManager, Identity, TableHeader} from 'wc-lib';
import {Service} from '../service';


@Component({
  template: require('./redirect.html'),
  components: {
    'environment-bar': EnvironmentBar,
    'aemo-footer': Footer
  }
})
export class Redirect extends Vue {
  
}



// WEBPACK FOOTER //
// src/views/redirect.ts